/* eslint-disable react/prop-types */
import React, { ReactElement } from 'react';
import getYear from 'date-fns/getYear';
import getMonth from 'date-fns/getMonth';
import { classes } from './DateInput';
import Button from '../Button';
import Select from '../Select';
import { ReactDatePickerCustomHeaderProps } from 'react-datepicker';

import LeftSmall from '@athena/forge-icons/dist/LeftSmall';
import RightSmall from '@athena/forge-icons/dist/RightSmall';

interface DateInputHeaderProps extends ReactDatePickerCustomHeaderProps {
  disabledKeyboardNavigation: boolean;
  minDate?: Date | null;
  maxDate?: Date | null;
}

const DateInputHeader = ({
  changeMonth,
  changeYear,
  date,
  decreaseMonth,
  disabledKeyboardNavigation,
  increaseMonth,
  nextMonthButtonDisabled,
  prevMonthButtonDisabled,
  minDate,
  maxDate,
}: DateInputHeaderProps): ReactElement => {
  const tabIndex = disabledKeyboardNavigation ? -1 : 0;
  const yearsOptions = [];
  if (minDate && maxDate) {
    const selectYearStart = getYear(minDate);
    const selectYearEnd = getYear(maxDate);
    for (let i = selectYearEnd; i >= selectYearStart; i--) {
      yearsOptions.push(i.toString());
    }
  }

  return (
    <div {...classes({ element: 'header' })} role="group">
      <Button
        {...classes({ element: 'header-button', modifiers: 'left' })}
        icon={LeftSmall}
        onClick={decreaseMonth}
        disabled={prevMonthButtonDisabled}
        tabIndex={tabIndex}
        variant="tertiary"
      />
      <Select
        {...classes({ element: 'header', extra: 'select-month' })}
        hasNullDefault={false}
        options={[
          { text: 'January', value: '0' },
          { text: 'February', value: '1' },
          { text: 'March', value: '2' },
          { text: 'April', value: '3' },
          { text: 'May', value: '4' },
          { text: 'June', value: '5' },
          { text: 'July', value: '6' },
          { text: 'August', value: '7' },
          { text: 'September', value: '8' },
          { text: 'October', value: '9' },
          { text: 'November', value: '10' },
          { text: 'December', value: '11' },
        ]}
        value={getMonth(date).toString()}
        onChange={({ target: { value } }: { target: { value: number } }) => changeMonth(value)}
        tabIndex={tabIndex}
      />
      <Select
        {...classes({ element: 'header', extra: 'select-year' })}
        hasNullDefault={false}
        options={yearsOptions}
        value={getYear(date).toString()}
        onChange={({ target: { value } }: { target: { value: number } }) => changeYear(value)}
        tabIndex={tabIndex}
      />
      <Button
        {...classes({ element: 'header-button', modifiers: 'right' })}
        icon={RightSmall}
        onClick={increaseMonth}
        disabled={nextMonthButtonDisabled}
        tabIndex={tabIndex}
        variant="tertiary"
      />
    </div>
  );
};

export default DateInputHeader;
